import type { APP_ENV } from '@main/shared/utils';
import { z } from 'zod/v4';

export const ironcladConnectionUrlSchema = z.url().check((ctx) => {
  const url = parseUrl(ctx.value);
  if (!url) return;
  if (
    (url.protocol !== 'http:' && url.protocol !== 'https:') ||
    url.username ||
    url.password ||
    url.search ||
    url.hash
  ) {
    ctx.issues.push({
      code: 'custom',
      input: ctx.value,
      message: 'Enter an HTTP or HTTPS URL without credentials, a query, or a fragment',
      params: { i18n: 'configureForm.validation.ironcladUrl' },
    });
  }
});

export const ironcladHostedUrlSchema = ironcladConnectionUrlSchema.check((ctx) => {
  const url = parseUrl(ctx.value);
  if (!url) return;
  const isIroncladHost =
    url.hostname === 'ironcladapp.com' || url.hostname.endsWith('.ironcladapp.com');
  if (url.protocol !== 'https:' || !isIroncladHost || url.pathname !== '/') {
    ctx.issues.push({
      code: 'custom',
      input: ctx.value,
      message: 'Enter an Ironclad HTTPS URL without a path',
      params: { i18n: 'configureForm.validation.ironcladHostedUrl' },
    });
  }
});

export function parseIroncladInstanceUrl(appEnv: APP_ENV, value: string): string {
  const instanceUrl =
    appEnv === 'local' || appEnv === 'staging'
      ? ironcladConnectionUrlSchema.parse(value)
      : ironcladHostedUrlSchema.parse(value);

  return instanceUrl.replace(/\/$/, '');
}

function parseUrl(value: string): URL | undefined {
  try {
    return new URL(value);
  } catch {
    return undefined;
  }
}
